import React, { useState, useEffect } from "react";
import { Avatar, Backdrop, CircularProgress, Link, Stack, Tooltip } from "@mui/material";
import { DeleteRounded, Star } from "@mui/icons-material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { productDetailApi, productAddImageApi } from "store/api";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import { Card, CardContent, Typography, Button, Chip, Grid, Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

// import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import "./styles.css";

// import required modules
import { Autoplay, FreeMode, Navigation, Thumbs, Keyboard, Pagination } from "swiper/modules";
import { useLocation, useNavigate } from "react-router";
import { fontSize, height, width } from "@mui/system";
import moment from "moment";
import AddImageDialog from "./AddImageDialog";
import Success from "components/Success";
import axios from "axios";
import UpdateImageDialog from "./UpdateImageDialog";
import { productUpdateBasicDetailsApi } from "store/api";
import EditReviewForm from "./editReviewForm";
import { productUpdateReviewApi } from "store/api";
import BoughtTogether from "./BoughtTogether";
import Grid2 from "@mui/material/Unstable_Grid2";
import { deleteProductBoughtTogetherApi } from "store/api";
// import Publish from "./Publish";

const ProductDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [msg, setMsg] = React.useState("");
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [updateOpen, setUpdateOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const productId = location.state?.productId;
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [addImage, setAddImage] = useState("");
  const [product, setProduct] = useState(null);
  const [images, setImages] = useState([]);
  const [updateReviewData, setUpdateReviewData] = useState({});
  const [reviewOpen, setReviewOpen] = useState(false);
  const redirect = data => {
    navigate("/product-details", { state: { productId: data.productId } });
  };
  const handleChangeUpdateReview = e => {
    const { value, name } = e.target;
    setUpdateReviewData(prev => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmitReview = async e => {
    e?.preventDefault();
    const response = await productUpdateReviewApi(updateReviewData);
    if (response?.success) {
      setMsg("Review update successfully");
      setOpenSuccess(true);
      setSuccess(true);
      getProductDetails();
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpenLoader(false);
  };
  const removeImage = index => {
    setImages(images.filter((_, i) => i !== index));
  };

  const getProductDetails = async () => {
    let data = {
      productId: productId,
    };
    const response = await productDetailApi(data);
    if (response?.success) {
      setProduct(response?.data);
    }
  };
  const [open, setOpen] = React.useState(false);
  const [seeButton, setSeeButton] = React.useState(false);
  const [manageImageData, setManageImageData] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickOpenUpdate = data => {
    setManageImageData(data);
    setUpdateOpen(true);
  };
  const handleClickOpenReview = data => {
    setUpdateReviewData(data);
    setReviewOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setManageImageData("");
  };
  const handleCloseReview = () => {
    setReviewOpen(false);
    setUpdateReviewData("");
  };
  const handleCloseUpdate = () => {
    setUpdateOpen(false);
  };
  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };
  useEffect(() => {
    if (productId) getProductDetails();
  }, [productId]);
  const [selectedColor, setSelectedColor] = useState("");
  const [publishData, setPublishData] = useState({});
  const handleColorChange = color => {
    setSelectedColor(color);
  };
  const currentColorData = product?.colors.find(c => c.colorCode === selectedColor);
  const uploadImage = async (e, action) => {
    e.preventDefault();
    const apiData = {
      productId: product?.productId,
      productColorId: currentColorData?.productColorId,
    };
    if (action == "update") apiData.productImageId = manageImageData?.productImageId;
    // if (action == "update") apiData.isActive = false;
    const response = await productAddImageApi(apiData);
    if (response?.success) {
      let uploadUrl = response?.data?.uploadUrl;
      const uploadResponse = await axios.put(uploadUrl, addImage?.image, {
        headers: { "Content-Type": addImage?.image?.type },
      });
      if (uploadResponse?.status) {
        setMsg("Image upload successfully");
        setOpenSuccess(true);
        setSuccess(true);
      } else {
        setOpenSuccess(true);
        setSuccess(false);
        setMsg("Something went wrong in upload image. Please try again later.");
      }
      getProductDetails();
      setOpen(false);
      handleCloseUpdate();
    }
  };

  const deleteImage = async e => {
    const apiData = {
      productId: product?.productId,
      productImageId: e?.productImageId,
      productColorId: currentColorData?.productColorId,
      isActive: false,
    };
    const response = await productAddImageApi(apiData);
    if (response?.success) {
      setMsg("Image delete successfully");
      setOpenSuccess(true);
      setSuccess(true);
      getProductDetails();
      setOpen(false);
      handleCloseUpdate();
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong in delete image. Please try again later.");
    }
  };
  const deleteBoughtTogether = async e => {
    const apiData = {
      productId1: e?.productId,
      productId2: product?.productId,
    };
    const response = await deleteProductBoughtTogetherApi(apiData);
    if (response?.success) {
      setMsg("Remove product successfully");
      setOpenSuccess(true);
      setSuccess(true);
      getProductDetails();
      setOpen(false);
      handleCloseUpdate();
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };

  const handleChange = e => {
    const { name } = e.target;
    setAddImage({
      [name]: e.currentTarget?.files[0],
    });
    const files = Array.from(e.target.files);
    const imageUrls = files?.map(file => URL.createObjectURL(file));
    setImages([...imageUrls]);
  };

  const [openLoader, setOpenLoader] = useState(false);
  const [openBt, setOpenBt] = useState(false);
  const handleCloseBT = () => {
    setOpenBt(false);
  };
  const handleOpenBT = () => {
    setOpenBt(true);
  };
  const handleChangePublish = async e => {
    setOpenLoader(true);
    const { value } = e?.target;
    if (product?.productId) {
      let data = {
        basicDetail: {
          isActive: value == "false" ? false : true,
          productId: product.productId,
        },
      };
      const response = await productUpdateBasicDetailsApi(data);
      if (response?.success) {
        setMsg("Publish status update successfully");
        setOpenSuccess(true);
        setSuccess(true);
        getProductDetails();
      } else {
        setOpenSuccess(true);
        setSuccess(false);
        setMsg("Something went wrong. Please try again later.");
      }
    }
    setOpenLoader(false);
  };
  const handleChangePublishReview = async (event, review) => {
    // setOpenLoader(true);
    const { value } = event?.target;
    let data = {
      isActive: value == "false" ? false : true,
      productReviewId: review.productReviewId,
    };
    const response = await productUpdateReviewApi(data);
    if (response?.success) {
      setMsg("Review update successfully");
      setOpenSuccess(true);
      setSuccess(true);
      getProductDetails();
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpenLoader(false);
  };

  const deleteReview = async data => {
    let apiData = {
      isDelete: true,
      productReviewId: data?.productReviewId,
    };
    const response = await productUpdateReviewApi(apiData);
    if (response?.success) {
      setMsg("Review Delete successfully");
      setOpenSuccess(true);
      setSuccess(true);
      getProductDetails();
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpenLoader(false);
  };

  const [seeButtonTrending, setSeeButtonTrending] = useState(false);
  const [trendingData, setTrendingData] = useState({});
  const handleChangeTrending = async e => {
    setOpenLoader(true);
    const { value } = e?.target;
    if (product?.productId) {
      let data = {
        basicDetail: {
          trending: value == "false" ? false : true,
          productId: product.productId,
        },
      };
      const response = await productUpdateBasicDetailsApi(data);
      if (response?.success) {
        setMsg("Publish status update successfully");
        setOpenSuccess(true);
        setSuccess(true);
        getProductDetails();
      } else {
        setOpenSuccess(true);
        setSuccess(false);
        setMsg("Something went wrong. Please try again later.");
      }
    }
    setOpenLoader(false);
  };

  const DeleteProduct = async productId => {
    setOpenLoader(true);
    const params = {
      productId: productId,
    };
    const response = await deleteProductApi(params);
    if (response?.response?.data) {
      setMsg(response?.response?.data?.message);
      setOpenSuccess(true);
      setSuccess(false);
      return;
    }
    if (response?.success) {
      setTimeout(() => {
        setMsg("Product Delete Successfully");
        setOpenSuccess(true);
        setSuccess(true);
      }, [4000]);
      setTimeout(() => {
        navigate("/products");
      }, [7000]);
    }
    if (!response?.success) {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };

  useEffect(() => {
    // if (product) setSelectedColor(product?.colors[0]?.colorCode);
    const activeColor = product?.colors?.find(color => color.isActive);
    if (activeColor) {
      setSelectedColor(activeColor.colorCode);
    }
  }, [product]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ padding: "32px", fontFamily: "Arial", position: "relative" }}>
        <div
          style={{
            position: "absolute",
            top: "30px",
            right: "20px",
            fontSize: "14px",
          }}
        >
          <div
            style={{
              cursor: "pointer",
              textAlign: "right",
              marginBottom: "8px",
              color: "#344767",
              fontWeight: 600,
            }}
            onClick={() => DeleteProduct(product?.productId)}
          >
            Delete
          </div>
          <div
            style={{
              cursor: "pointer",
              textAlign: "right",
              marginBottom: "8px",
              color: "#344767",
              fontWeight: 600,
            }}
            onClick={() => navigate("/edit-product", { state: { productId: product?.productId } })}
          >
            Edit
          </div>
          <div
            style={{
              cursor: "pointer",
              textAlign: "right",
              marginBottom: "8px",
              color: "#344767",
              fontWeight: 600,
            }}
            onClick={() => navigate("/clone-product", { state: { product: product } })}
          >
            Clone
          </div>

          <div
            style={{
              cursor: "pointer",
              textAlign: "right",
              marginBottom: "8px",
              color: "#344767",
              fontWeight: 600,
            }}
            onClick={() => handleOpenBT()}
          >
            Bought Together
          </div>
        </div>
        {/* Header Section */}
        <Grid container spacing={4}>
          <Grid style={{ height: "500px", position: "sticky", top: "90px" }} item xs={12} md={4}>
            {currentColorData?.images?.length > 0 && (
              <Swiper
                style={{
                  "--swiper-navigation-color": "#fff",
                  "--swiper-pagination-color": "#fff",
                  borderRadius: "10px",
                }}
                loop={true}
                spaceBetween={10}
                // navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Thumbs]}
                className='mySwiper2'
              >
                {currentColorData?.images.map((e, i) => (
                  <SwiperSlide style={{ position: "relative" }}>
                    <img src={e?.image} style={{ objectFit: "contain" }} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
            {currentColorData?.images?.length == 0 && (
              <div
                style={{
                  border: "1px dashed gray",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  height: "100%",
                  borderRadius: "12px",
                  cursor: "pointer",
                }}
                onClick={() => handleClickOpen()}
              >
                <AddPhotoAlternateOutlinedIcon />
                <p>Add image</p>
              </div>
            )}
            <Swiper
              onSwiper={setThumbsSwiper}
              loop={true}
              spaceBetween={10}
              slidesPerView={4}
              freeMode={true}
              watchSlidesProgress={true}
              modules={[FreeMode, Navigation, Thumbs]}
              className='mySwiper'
              style={{ overflowX: "scroll" }}
            >
              {currentColorData?.images.map((e, i) => (
                <SwiperSlide style={{ cursor: "pointer", position: "relative" }}>
                  <div
                    style={{
                      position: "absolute",
                      right: "3px",
                      top: "3px",
                      color: "rgb(52, 71, 103)",
                    }}
                  >
                    <Tooltip title='Delete'>
                      <DeleteRounded
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          deleteImage(e);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title='Update'>
                      <DriveFileRenameOutlineRoundedIcon
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickOpenUpdate(e);
                        }}
                      />
                    </Tooltip>
                  </div>
                  <img src={e?.image} style={{ objectFit: "contain" }} />
                </SwiperSlide>
              ))}
              {currentColorData?.images?.length > 0 && (
                <SwiperSlide style={{ border: "1px dashed gray", order: 99999 }}>
                  <label>
                    {/* <input
                    type='file'
                    accept='image/*'
                    multiple
                    // onChange={handleImageUpload}
                    style={{ display: "none" }}
                  /> */}
                    <div
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        width: "100%",
                        height: "100%",
                        gap: "6px",
                      }}
                      onClick={() => handleClickOpen()}
                    >
                      <AddPhotoAlternateOutlinedIcon />
                      <p style={{ fontSize: "12px", lineHeight: "14px" }}>Add image</p>
                    </div>
                  </label>
                </SwiperSlide>
              )}
            </Swiper>
          </Grid>

          {/* Product Information Section */}
          <Grid item xs={12} md={8}>
            <div style={{ maxWidth: "calc(100% - 124px)" }}>
              <Typography sx={{ fontWeight: "500", marginBottom: "8px" }}>
                {product?.nameEn}
              </Typography>
              <Typography sx={{ fontWeight: "500", marginBottom: "8px" }}>
                {product?.nameUz}
              </Typography>
            </div>
            <Typography sx={{ color: "gray", fontSize: "12px" }}>
              PRODUCT ID: {product?.productCode}
            </Typography>
            {/* <Typography sx={{ padding: "10px 0", fontSize: "16px", fontWeight: "500" }}>
              Product short description
            </Typography>
            <Typography sx={{ marginBottom: "16px", fontSize: "16px" }}>
              Nec ultrices dui sapien eget. Duis ut diam quam nulla porttitor massa id neque
              aliquam.
            </Typography> */}

            <Grid
              container
              spacing={2}
              sx={{
                marginBottom: "16px",
                marginTop: "16px",
                padding: "12px",
                border: "1px solid #EBF0ED",
                background: "#FAFAFA",
                borderRadius: "16px",
              }}
            >
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography variant='h5' sx={{ fontWeight: "bold" }}>
                  ₴{product?.price}
                </Typography>
                <Typography variant='caption'>Price</Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography variant='h5' sx={{ fontWeight: "bold" }}>
                  {product?.rating ? product?.rating : "---"}
                </Typography>
                <Typography variant='caption'>Rating</Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography variant='h5' sx={{ fontWeight: "bold" }}>
                  {product?.productReview?.length > 0 ? product?.productReview?.length : "---"}
                </Typography>
                <Typography variant='caption'>Review Count</Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography
                  variant='h5'
                  sx={{
                    fontWeight: "bold",
                    color:
                      !currentColorData?.inventory || currentColorData?.inventory < 1
                        ? "red"
                        : currentColorData?.inventory < 10
                          ? "orange"
                          : "",
                  }}
                >
                  {currentColorData?.inventory ? currentColorData?.inventory : "Out of Stock"}
                </Typography>
                <Typography
                  variant='caption'
                  sx={{
                    color:
                      !currentColorData?.inventory || currentColorData?.inventory < 1
                        ? "red"
                        : currentColorData?.inventory < 10
                          ? "orange"
                          : "",
                  }}
                >
                  Available Stocks
                </Typography>
              </Grid>
            </Grid>

            {/* Sizes */}
            {/* <Typography variant='h6'>Sizes:</Typography>
            <Box sx={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
              {["XS", "S", "M"].map(size => (
                <Chip key={size} label={size} variant='outlined' />
              ))}
            </Box> */}

            {/* Colors */}
            <Typography variant='h6'>Colors:</Typography>
            <Box sx={{ display: "flex", gap: "8px", marginBottom: "16px", alignItems: "center" }}>
              {product?.colors.map(color =>
                color?.isActive ? (
                  <Box
                    key={color.productColorId}
                    onClick={() => handleColorChange(color.colorCode)}
                    sx={{
                      borderRadius: "6px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: `1px solid ${color?.colorCode}`,
                      backgroundColor: `${selectedColor == color?.colorCode}`,
                      width: `${selectedColor == color.colorCode ? "32px" : "24px"}`,
                      height: `${selectedColor == color.colorCode ? "32px" : "24px"}`,
                      cursor: "pointer",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: `${color?.colorCode}`,
                        width: "24px",
                        height: "24px",
                        display: "inline-block",
                        borderRadius: "4px",
                      }}
                    ></span>
                  </Box>
                ) : (
                  ""
                )
              )}
            </Box>
            {/* Description */}
            {/* <Typography variant='h6' sx={{ fontWeight: "bold", marginBottom: "8px" }}>
              Product Description
            </Typography>
            <Typography variant='body2' sx={{ color: "gray" }}>
              Vestibulum tristique sollicitudin nibh sit amet. Semper tristique sollicitudin nibh
              sit amet.
            </Typography> */}

            {/* Additional Information */}
            <Typography variant='h6' sx={{ fontWeight: "bold", marginTop: "24px" }}>
              Additional Information
            </Typography>
            <Box
              sx={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                marginTop: "10px",
                padding: "12px",
              }}
            >
              <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                Publish Status
              </Typography>
              <div style={{ display: "flex", gap: "8px", fontSize: "14px", alignItems: "center" }}>
                <div
                  style={
                    product?.isActive
                      ? {
                        borderRadius: "5px",
                        backgroundColor: "green",
                        width: "10px",
                        height: "10px",
                      }
                      : {
                        borderRadius: "5px",
                        backgroundColor: "red",
                        width: "10px",
                        height: "10px",
                      }
                  }
                ></div>
                <div>{product?.isActive ? "Published" : "Draft"}</div>
                <Tooltip title={product?.isActive ? "Draft" : "Published"}>
                  <PublishSwitch
                    onChange={handleChangePublish}
                    value={!product?.isActive}
                    inputProps={{ "aria-label": "controlled" }}
                    checked={product?.isActive}
                  />
                </Tooltip>

                {/* <div
                  style={
                    product?.trending
                      ? {
                          borderRadius: "5px",
                          backgroundColor: "green",
                          width: "10px",
                          height: "10px",
                        }
                      : {
                          borderRadius: "5px",
                          backgroundColor: "red",
                          width: "10px",
                          height: "10px",
                        }
                  }
                ></div>
                <div>{product?.trending ? "Yes" : "No"}</div>
                <PublishSwitch
                  onChange={handleChangeTrending}
                  value={!product?.trending}
                  inputProps={{ "aria-label": "controlled" }}
                  checked={product?.trending}
                /> */}
                <Backdrop
                  sx={theme => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                  open={openLoader}
                >
                  <CircularProgress color='inherit' />
                </Backdrop>
              </div>
            </Box>
            <Box
              sx={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                marginTop: "20px",
                padding: "12px",
              }}
            >
              <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                Warranty
              </Typography>
              {product?.warranty?.length == 0 && (
                <div style={{ fontSize: "14px" }}>No Warranty Apply Yet!</div>
              )}
              {product?.warranty?.length > 0 && (
                <div style={{ display: "flex", gap: "40px", padding: "5px" }}>
                  <div>
                    <div style={{ fontSize: "14px", fontWeight: "500" }}>Ukrain</div>
                    {product?.warranty?.map(e => (
                      <Typography style={{ fontSize: "12px", color: "gray" }}>
                        {e?.descriptionUz}
                      </Typography>
                    ))}
                  </div>
                  <div>
                    <div style={{ fontSize: "14px", fontWeight: "500" }}>English</div>
                    {product?.warranty?.map(e => (
                      <Typography style={{ fontSize: "12px", color: "gray" }}>
                        {e?.descriptionEn}
                      </Typography>
                    ))}
                  </div>
                  <div>
                    <div style={{ fontSize: "14px", fontWeight: "500" }}>Price</div>
                    {product?.warranty?.map(e => (
                      <Typography style={{ fontSize: "12px", color: "gray" }}>
                        ₴{e?.price}
                      </Typography>
                    ))}
                  </div>
                  <div></div>
                  {/* <div>
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>{e.price}</div>
                </div> */}
                </div>
              )}
            </Box>
            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              <Grid item xs={12} md={12}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Characteristics
                  </Typography>
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>Ukrain</div>
                  {product?.characteristics?.length == 0 && (
                    <Typography
                      style={{
                        fontSize: "12px",
                        color: "gray",
                      }}
                    >
                      Not yet!
                    </Typography>
                  )}
                  {product?.characteristics?.map(e => (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        {e?.valueUz}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        {e?.keyUz}
                      </Typography>
                    </div>
                  ))}
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>English</div>
                  {product?.characteristics?.length == 0 && (
                    <Typography
                      style={{
                        fontSize: "12px",
                        color: "gray",
                      }}
                    >
                      Not yet!
                    </Typography>
                  )}
                  {product?.characteristics?.map(e => (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        {e?.valueUz}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        {e?.keyUz}
                      </Typography>
                    </div>
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Descriptions
                  </Typography>
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>Ukrain</div>
                  {product?.descriptions?.length == 0 && (
                    <Typography
                      style={{
                        fontSize: "12px",
                        color: "gray",
                      }}
                    >
                      Not yet!
                    </Typography>
                  )}
                  {product?.descriptions?.map(e => (
                    <Typography style={{ fontSize: "12px", color: "gray" }}>
                      {e?.descriptionUz}
                    </Typography>
                  ))}
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>English</div>
                  {product?.descriptions?.length == 0 && (
                    <Typography
                      style={{
                        fontSize: "12px",
                        color: "gray",
                      }}
                    >
                      Not yet!
                    </Typography>
                  )}
                  {product?.descriptions?.map(e => (
                    <Typography style={{ fontSize: "12px", color: "gray" }}>
                      {e?.descriptionEn}
                    </Typography>
                  ))}
                </Box>
              </Grid>
            </div>
            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              {/* Ratings Section */}
              <Grid item xs={12} md={6}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold", marginBottom: "8px" }}>
                    Ratings & Reviews
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <div
                      style={{
                        fontWeight: "bold",
                        backgroundColor:
                          product?.rating == 5 ? "green" : product?.rating >= 4 ? "blue" : "orange",
                        borderRadius: "6px",
                        fontSize: "16px",
                        color: "white",
                        padding: "4px 20px",
                      }}
                    >
                      {product?.rating}
                    </div>
                    <div>
                      {[1, 2, 3, 4].map(e => (
                        <Star
                          sx={{
                            color:
                              product?.rating == 5
                                ? "green"
                                : product?.rating >= 4
                                  ? "blue"
                                  : "orange",
                            padding: 0,
                            width: "12px",
                            height: "14px",
                          }}
                        />
                      ))}
                      {product?.productReview?.left > 0 && (
                        <div style={{ fontSize: "12px", marginTop: "-10px" }}>
                          Based on {product?.productReview?.length} Reviews
                        </div>
                      )}
                    </div>
                  </Box>
                  {/* Star Breakdown */}
                  {[5, 4, 3, 2, 1].map(star => (
                    <Box
                      key={star}
                      sx={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}
                    >
                      <Typography style={{ fontSize: "12px" }}>{star} Stars</Typography>
                      <Box
                        sx={{
                          flexGrow: 1,
                          height: "8px",
                          backgroundColor: "#ddd",
                          position: "relative",
                          borderRadius: "12px",
                        }}
                      >
                        <Box
                          sx={{
                            width: `${star * 20}%`,
                            backgroundColor: star === 5 ? "green" : star === 4 ? "blue" : "orange",
                            height: "100%",
                            borderRadius: "12px",
                          }}
                        ></Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Grid>
              {/* Reviews Section */}
              <Grid item xs={12} md={6}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Reviews{" "}
                    {product?.productReview?.length > 0
                      ? "(" + product?.productReview?.length + ")"
                      : ""}
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      marginTop: "10px",
                    }}
                  >
                    {product?.productReview?.length == 0 && (
                      <div style={{ fontSize: "14px" }}>No Review Yet!</div>
                    )}
                    {/* <div
                      style={{
                        boxShadow: "0 0 4px 1px rgba(0,0,0,0.1)",
                        borderRadius: "10px",
                        padding: "5px 10px",
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Box sx={{ display: "flex", gap: "8px" }}>
                              <Typography variant='subtitle1' style={{ fontSize: "14px" }}>
                                name
                              </Typography>
                            </Box>
                          </Box>
                          <Typography variant='body2' sx={{ fontSize: "12px" }}>
                            review
                          </Typography>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <Tooltip title={"Edit"} style={{ cursor: "pointer" }}>
                              <EditNoteRoundedIcon
                                onClick={() => {
                                  handleClickOpenReview({
                                    rating: 4,
                                    review: "Test",
                                  });
                                }}
                                style={{ padding: "1px" }}
                              />
                            </Tooltip>
                            <Typography variant='caption'>Date</Typography>
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: "0px" }}>
                            <Tooltip title='Delete' style={{ cursor: "pointer", padding: "2px" }}>
                              <DeleteRounded onClick={() => deleteReview("")} />
                            </Tooltip>
                            <Tooltip title={"Status"}>
                              <PublishSwitch
                                onChange={e =>
                                  handleChangePublishReview(e, {
                                    productReviewId: "2ae35ed7-796a-4b8c-b842-b598f60bb341",
                                  })
                                }
                                value={false}
                                inputProps={{ "aria-label": "controlled" }}
                                checked={true}
                              />
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {product?.productReview?.length > 0 &&
                      product?.productReview?.map(e => (
                        <div
                          style={{
                            boxShadow: "0 0 4px 1px rgba(0,0,0,0.1)",
                            borderRadius: "10px",
                            padding: "5px 10px",
                          }}
                        >
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Box sx={{ display: "flex", gap: "8px" }}>
                                  <Typography variant='subtitle1' style={{ fontSize: "14px" }}>
                                    {e?.name}
                                  </Typography>
                                </Box>
                              </Box>
                              <Typography variant='body2' sx={{ fontSize: "12px" }}>
                                {e?.review}
                              </Typography>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "end",
                              }}
                            >
                              {/* <DeleteRoundedIcon style={{ padding: "3px" }} /> */}
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Tooltip title={"Edit"} style={{ cursor: "pointer" }}>
                                  <EditNoteRoundedIcon
                                    onClick={() => {
                                      handleClickOpenReview(e);
                                    }}
                                    style={{ padding: "1px" }}
                                  />
                                </Tooltip>
                                <Typography variant='caption'>
                                  {moment(e?.createdAt).format("ll")}
                                </Typography>
                              </div>
                              <div style={{ display: "flex", alignItems: "center", gap: "0px" }}>
                                <Tooltip
                                  title='Delete'
                                  style={{ cursor: "pointer", padding: "2px" }}
                                >
                                  <DeleteRounded onClick={() => deleteReview(e)} />
                                </Tooltip>
                                <Tooltip title={"Status"}>
                                  <PublishSwitch
                                    onChange={event =>
                                      handleChangePublishReview(event, {
                                        productReviewId: e?.productReviewId,
                                      })
                                    }
                                    value={!e?.isActive}
                                    inputProps={{ "aria-label": "controlled" }}
                                    checked={e?.isActive}
                                  />
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </Box>
              </Grid>
            </div>
            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              {/* Video Section */}
              <Grid item xs={12} md={12}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Video
                  </Typography>
                  {product?.videos?.length == 0 && (
                    <div style={{ fontSize: "14px" }}>No Video Yet!</div>
                  )}
                  {product?.videos?.length > 0 && (
                    <div
                      className='video-gallery'
                      style={{ display: "flex", flexWrap: "wrap", gap: "16px", padding: "16px 0" }}
                    >
                      {product?.videos?.map((e, index) => (
                        <div className='video-box' key={index} style={{ borderRadius: "12px" }}>
                          <iframe
                            width='240'
                            height='160'
                            src={`https://www.youtube.com/embed/${e?.video?.split("v=")[1]}`}
                            title={`YouTube Video ${index + 1}`}
                            frameBorder='0'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                            allowFullScreen
                            style={{ borderRadius: "12px" }}
                          ></iframe>
                        </div>
                      ))}
                    </div>
                  )}
                </Box>
              </Grid>
            </div>
            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              {/* Video Section */}
              <Grid item xs={12} md={12}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Bought Together Product List
                  </Typography>
                  {product?.frequentlyBoughtProduct?.length == 0 && (
                    <div style={{ fontSize: "14px" }}>No Product Yet!</div>
                  )}
                  <Grid2 container py={3} spacing={3}>
                    {product?.frequentlyBoughtProduct?.length > 0 &&
                      product?.frequentlyBoughtProduct?.map(product => (
                        <ProductNew
                          redirect={redirect}
                          product={product}
                          deleteBoughtTogether={deleteBoughtTogether}
                        />
                      ))}
                    {/* // <div
                    //   className='video-gallery'
                    //   style={{
                    //     display: "flex",
                    //     flexWrap: "wrap",
                    //     gap: "0px",
                    //     padding: "16px 0",
                    //   }}
                    // > */}
                    {/* // </div> */}
                  </Grid2>
                </Box>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Box>
      <Footer />
      <AddImageDialog
        open={open}
        images={images}
        removeImage={removeImage}
        uploadImage={uploadImage}
        handleClose={handleClose}
        handleChange={handleChange}
      />
      <EditReviewForm
        open={reviewOpen}
        handleClose={handleCloseReview}
        handleSubmit={handleSubmitReview}
        updateReviewData={updateReviewData}
        handleChangeUpdateReview={handleChangeUpdateReview}
      />
      <UpdateImageDialog
        open={updateOpen}
        images={images}
        setImages={setImages}
        removeImage={removeImage}
        uploadImage={uploadImage}
        // deleteImage={deleteImage}
        handleClose={handleCloseUpdate}
        handleChange={handleChange}
        addImage={addImage}
        setAddImage={setAddImage}
        manageImageData={manageImageData}
      />
      <BoughtTogether
        open={openBt}
        handleClose={handleCloseBT}
        product={product}
        getProductDetails={getProductDetails}
      />
      <Success open={openSuccess} success={success} msg={msg} handleClose={handleCloseSuccess} />
    </DashboardLayout>
  );
};

export default ProductDetails;

const PublishSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  paddingRight: 0,
  gap: 0,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    height: 18,
    width: 38,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 18,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 9,
      marginTop: -1,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
      marginTop: -1,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
  },
}));
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import { deleteProductApi } from "store/api";

const ProductNew = ({ product, redirect, deleteBoughtTogether }) => {
  const [selectedColor, setSelectedColor] = React.useState("");
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);
  const handleColorChange = color => {
    setSelectedColor(color);
  };
  const currentColorData = product?.colors.find(c => c.colorCode === selectedColor);
  React.useEffect(() => {
    // if (product) setSelectedColor(product?.colors[0]?.colorCode);
    const activeColor = product?.colors?.find(color => color.isActive);
    if (activeColor) {
      setSelectedColor(activeColor.colorCode);
    }
  }, [product]);
  return (
    <Grid2 xs={12} sm={6} md={4} style={{ border: "16px", overflow: "hidden" }}>
      <Card style={{ cursor: "pointer" }}>
        <Swiper
          style={{
            "--swiper-navigation-color": "#fff",
            "--swiper-pagination-color": "#fff",
            height: "160px",
            position: "relative",
          }}
          loop={true}
          spaceBetween={10}
          pagination={true}
          modules={[FreeMode, Thumbs, Pagination]}
          className='mySwiper2'
        >
          <div
            style={{
              top: 0,
              width: "100%",
              height: "100%",
              zIndex: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
              borderRadius: "16px 16px 0 0",
              flexDirection: "column",
              textTransform: "uppercase",
              gap: "16px",
            }}
          >
            <div
              style={{
                border: "1px solid #636363",
                backgroundColor: "rgba(170,170,170,0.35)",
                borderRadius: "50%",
                height: "40px",
                width: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#636363",
              }}
            >
              <ImageNotSupportedIcon style={{ fontSize: "40px", fill: "#636363" }} />
            </div>
            <div style={{ fontSize: "10px" }}>Comming Soon</div>
          </div>
          <div
            style={{
              position: "absolute",
              right: "10px",
              top: "5px",
              color: "black",
              zIndex: "1055",
            }}
          >
            <Tooltip title='Delete'>
              <DeleteRounded
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  deleteBoughtTogether(product);
                }}
              />
            </Tooltip>
          </div>
          {currentColorData?.images.map((e, i) => (
            <SwiperSlide className='mySwiper5' style={{ position: "relative" }}>
              <img
                alt='product'
                src={e.image}
                style={{
                  top: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 2,
                  objectFit: "contain",
                  position: "absolute",
                  borderRadius: "16px 16px 0 0",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <Stack spacing={2} sx={{ px: 3, py: 2 }}>
          <Link
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "500" }}
            noWrap
            onClick={() => redirect(product)}
          >
            {product?.nameEn}
            <br />
            {product?.nameUz}
          </Link>

          <Box display='flex' alignItems='center' justifyContent='space-between'>
            <Box class='MuiBox-root css-udwogp'>
              {product?.colors?.map((e, i) =>
                e?.isActive ? (
                  <Box
                    className={`MuiBox-root ${i == 0 ? "css-1r15jgt" : i == 1 ? "css-1ebeuj6" : i == 2 ? "css-16couxa" : ""
                      }`}
                    onClick={() => handleColorChange(e.colorCode)}
                    style={{ backgroundColor: e.colorCode }}
                  ></Box>
                ) : (
                  ""
                )
              )}
            </Box>
            <Typography
              variant='subtitle1'
              style={{
                fontSize: "0.875rem",
                fontWeight: "500",
                alignItems: "center",
                gap: "6px",
                display: "flex",
              }}
            >
              <div
                style={{
                  color: "red",
                  textDecoration: "line-through",
                  fontSize: "10px",
                  opacity: "0.6",
                }}
              >
                ₴{product?.price}
              </div>
              ₴{product?.discountPrice}
            </Typography>
          </Box>
        </Stack>
      </Card>
    </Grid2>
  );
};
